import React from 'react'
import Topbar from '../Topbar'
import {Button, ButtonToolbar} from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import {find} from 'lodash'

import IconTooltip from '../../components/IconTooltip'
import Question from '../../components/Question'
import {buildAnswerMap} from '../../utils'

import * as question from '../../services/question-service'
import * as collaborators from '../../services/collaborator-service'
import * as location from '../../services/location-service'
import * as unitService from '../../services/organizational-units-service'
import * as scanService from '../../services/scan-service'
import * as answerService from '../../services/answer-service'
import * as consultationService from '../../services/consultation-service'
import {CollaboratorsContext} from '../../context/CollaboratorsContext'
import {EmailContext} from '../../context/EmailContext'

export default class IntroQuestions extends React.Component {
  constructor(props) {
    super(props)
    this.handleLocationChange = this.handleLocationChange.bind(this)
    this.handleUnitChange = this.handleUnitChange.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.back = this.back.bind(this)
    this.checkBoxFormatter = this.checkBoxFormatter.bind(this)
    this.changeCollaborator = this.changeCollaborator.bind(this)

    this.state = {
      units: [],
      locations: [],
      collaborators: [],
      questions: {genericQuestions: []},
      answers: [],
      scan: {},
      isIntroQuestions: true
    }
  }

  componentDidMount() {
    location.getLocations().then(locations => {
      this.setState({locations}, () => {
        if (this.props.match.params.scanId) {
          this.getScan(this.props.match.params.scanId)
        }
      })
    })
  }

  getScan(scanId) {
    Promise.all([scanService.getScanById(scanId), answerService.getAnswers(scanId)]).then(([scan, answers]) => {
      let location = find(this.state.locations, location => location.name === scan.locationName)

      unitService.getUnitsByLocation(location.id).then(units => {
        let unit = find(units, unit => unit.id === scan.organizationalUnitId)

        this.setState({scan, answers, units, location, unit}, () => {
          this.getInitData()
        })
      })
    })
  }

  getInitData() {
    const unitId = this.state.unit.id
    const scanId = this.state.scan.id
    Promise.all([
      collaborators.getCollaboratorsByUnit(unitId),
      question.getQuestion(1,scanId),
      consultationService.getAllCollaboratorsPerScan(scanId)
    ]).then(([collaborators, questions, consultations]) => {
      collaborators.forEach(col => {
        (col.fullName = col.firstName + ' ' + (col.prefix || '') + ' ' + col.lastName)
        col.selected = !!find(consultations, c => c.collaboratorId === col.id)
        col.initiallySelected = !!find(consultations, c => c.collaboratorId === col.id)
        col.consultation = find(consultations, c => c.collaboratorId === col.id)
      })
      this.setState({
        collaborators,
        questions
      })
    })
  }

  handleLocationChange(location) {
    this.setState({location}, () =>
      unitService.getUnitsByLocation(this.state.location.id).then(units => this.setState({units}))
    )
  }

  handleUnitChange(unit) {
    this.setState({unit}, () => this.getInitData())
  }

  handleChange(e, values) {
    const { scanId } = this.props.match.params
    const optionId = parseInt(e.target.value, 10)

    let {answers} = this.state
    let promises = []
    for (let i = 0; i < values.length; i++) {
      let booleanValue = values[i] === optionId

      promises.push(answerService.upsertAnswer({scanId, optionId: values[i], booleanValue}))

      let answer = find(answers, a => a.optionId === values[i])
      if (!answer) {
        answer = {scanId, optionId: values[i]}
        answers.push(answer)
      }
      answer.booleanValue = booleanValue
    }

    Promise.all(promises).then(() => {
      this.setState({answers})
    })
  }

  getOptions(questionId) {
    const {genericQuestions} = this.state.questions

    let optionIds = []
    if (genericQuestions) {
      genericQuestions[questionId].options.forEach(option => optionIds.push(option.id))
    }
    return optionIds
  }

  changeCollaborator(row, id) {
    let collaborators = this.state.collaborators
    collaborators[id].selected = !collaborators[id].selected
    collaborators[id].initiallySelected = collaborators[id].selected

    const collaboratorId = collaborators[id].id
    let updateBackend = null
    if (collaborators[id].selected) {
      updateBackend = () => consultationService.addCollaborator(
        {
          scanId: this.state.scan.id,
          collaboratorId: collaboratorId
        }).then((resp) => {
        let newCollaborators = this.state.collaborators
        newCollaborators[id].consultation = resp
        this.setState({collaborators: newCollaborators})
      })
    } else {
      updateBackend = () => consultationService.deleteCollaborator(collaborators[id].consultation.id)
    }
    this.setState({collaborators: collaborators}, updateBackend)
  }

  checkBoxFormatter(cell, row, id) {
    const completed = !!this.state.scan.completedDate
    return (
      <div className="row-actions">
        <form>
          <div className="checkbox">
            <label>
              <input type="checkbox" checked={row.selected} disabled={completed} onChange={() => this.changeCollaborator(row, id)}/>
              <span className="text">&nbsp;</span>
            </label>
          </div>
        </form>
      </div>
    )
  }

  headerFormatter(column, colIndex, {sortElement}) {
    return (
      <span className="sortable-inner">
        <span className="text">{column.text}</span>
        {sortElement}
      </span>
    )
  }

  contentFormatter(cell, row) {
    return <span className="text">{cell}</span>
  }

  back() {
    this.props.history.push(`/scans/`)
  }

  render() {
    const {questions, units, locations, collaborators, scan, answers, location, unit} = this.state
    const {genericQuestions} = questions
    const completed = !!scan.completedDate
    const columns = [
      {
        dataField: 'button',
        text: ' ',
        formatter: this.checkBoxFormatter
      },
      {
        dataField: 'fullName',
        text: 'Medewerker',
        sort: true,
        headerFormatter: this.headerFormatter,
        formatter: this.contentFormatter
      },
      {
        dataField: 'email',
        text: 'E-mail',
        sort: true,
        headerFormatter: this.headerFormatter,
        formatter: this.contentFormatter
      }
    ]

    return (
      <div className="content table-page col-2 scans new-scan">
        <div className="content-inner">
          <Topbar
            title="Scan"
            select={true}
            location={location}
            locations={locations}
            unit={unit}
            units={units}
            disabled={false}
            unitChange={this.handleUnitChange}
            locationChange={this.handleLocationChange}
          />

          <div className="inner">
            <div className="scan-container row">
              <div className="scan-section col">
                <h2>
                  Vragen vooraf{' '}
                  {genericQuestions[0] &&
                  <IconTooltip text={genericQuestions[0].explanation} icon="far fa-info-circle"/>}
                </h2>

                {genericQuestions &&
                genericQuestions.map((question, i) => (
                  <Question
                    key={i}
                    question={question}
                    onChange={this.handleChange}
                    state={answers}
                    completed={completed}
                    answermap={buildAnswerMap(questions, answers)}
                    isIntroQuestions={this.state.isIntroQuestions}
                    
                  />
                ))}
              </div>
              <div className="scan-section col">
                <h2>Raadplegen medewerkers</h2>
                <div className="user-table">
                  {this.state.collaborators && (
                    <BootstrapTable
                      keyField="id"
                      data={collaborators}
                      columns={columns}
                      bordered={false}
                      striped
                      hover
                      condensed
                    />
                  )}
                </div>
              </div>
            </div>
          </div>

          <div id="action-buttons">
            <ButtonToolbar>
              <CollaboratorsContext.Consumer>
                {context => (<Button bsStyle="primary" onClick={(e) => {
                  window.sessionStorage.setItem('collaborators', JSON.stringify(this.state.collaborators))
                  context.updateCollaborators()
                  this.props.history.push(`/scans/${this.props.match.params.scanId}/next`)
                }}>
                  {completed ? "Bekijk antwoorden" : "Voortzetten scan"}
                </Button>)}
              </CollaboratorsContext.Consumer>
              <EmailContext.Consumer>
                {ctx => {
                  if (ctx.state.shallActivateEmailButton || ctx.state.isFeedbackSent) {
                    ctx.resetEmailContext()
                  }
                }}
              </EmailContext.Consumer>

              <Button onClick={this.back}>Annuleren</Button>

            </ButtonToolbar>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Scan/IntroQuestions.js